import { fetcher, queryString, useRecoilQuery } from '@shared/hooks/recoil-query';
import { LowerRole } from '@shared/types';

import {
  giftItemBrandDataAtomFamily,
  giftItemBrandListDataAtom,
  giftItemBrandListStatusAtom,
  giftItemBrandStatusAtomFamily,
} from './giftItemBrand.atom';

// GiftItemBrand 목록 조회
const giftItemBrandListUrl = (role: LowerRole) => {
  return `/${role}/gift-item-brand?${queryString({
    options: { sort: { name: 1 } },
  })}`;
};

export const useGiftItemBrandListHook = (role: LowerRole, skip = false) => {
  useRecoilQuery(
    giftItemBrandListStatusAtom,
    giftItemBrandListDataAtom,
    giftItemBrandListUrl(role),
    fetcher,
    skip,
  );
};

// GiftItemBrand 단건 조회
const giftItemBrandUrl = (id: string, role: LowerRole) => {
  return `/${role}/gift-item-brand/${id}`;
};

export const useGiftItemBrandHook = (id: string, role: LowerRole, skip = false) => {
  useRecoilQuery(
    giftItemBrandStatusAtomFamily(id),
    giftItemBrandDataAtomFamily(id),
    giftItemBrandUrl(id, role),
    fetcher,
    skip || !id,
  );
};
